import React, { forwardRef } from 'react';
import ManageTestUI from '../../../ui/ManageTest/ManageTestUI';

const ManageTests = forwardRef((props, ref) => {
  return <ManageTestUI {...props} role="admin" ref={ref} />;
});

export default ManageTests;
